/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {checkDNSTarget} from "../../Objects/Domains.jsx";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import IconButtonComponent from "../BasicInputs/IconButtonComponent.jsx";
import {Util} from "../../Utilities.js";
import Strings from "toolbox/strings";

class ValidateDomainTarget extends Component {
    constructor() {
        super();

        this.state = {
            isCorrect: false
        }
    }

    async validateTarget() {
        let {domainName, domainTarget} = this.props
        if (Strings.isEmpty(domainName)) {
            this.setState({isCorrect: false})
            return
        }

        let isCorrect = await checkDNSTarget(domainName, domainTarget)

        if (isCorrect !== this.state.isCorrect) {
            this.setState({isCorrect: isCorrect})
        }

    }

    componentDidMount() {
        this.validateTarget()

        this.interval = setInterval(() => {
            this.validateTarget()
        }, 3000)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.domainName !== this.props.domainName || prevProps.domainTarget !== this.props.domainTarget) {
            this.validateTarget()
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    render() {
        let {isCorrect} = this.state
        return (
            <div
                className={`w-full rounded  h-12 text-white flex items-center p-2  ${isCorrect ? ("bg-green-700") : ("bg-blue-700")}  `}>
                <div className={"grow flex items-center gap-2"}>
                    {isCorrect ? (<>
                        <DisplayIcon iconName={"IoIosCheckmarkCircle"}/>

                        <p>The DNS Record is Correct</p>


                    </>) : (<>
                        <DisplayIcon iconName={"MdOutlinePending"}/>
                        <p>Check that the DNS Record is set</p>

                    </>)}
                </div>
                <IconButtonComponent iconName={"IoReload"} text={"Re Validate"} onClick={async () => {
                    await this.validateTarget()
                    // add artificial wait to keep the button spinning so the user sees that something is happening
                    await Util.time.sleep(2000)
                }}/>


            </div>
        );
    }
}

ValidateDomainTarget.propTypes = {};

ValidateDomainTarget.defaultProps = {};


export default ValidateDomainTarget;